// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Slupy_schodowe_productTextBody__pV4Gm","green":"Slupy_schodowe_green__5TzZf"};